import { Text } from '@youversion/design-system-components';
import { PayPal } from 'components/images';
import React from 'react';

import PaymentMethodBox from './PaymentMethodBox';

interface Props {
  editing: boolean;
  onClick: () => void;
  selected: boolean;
}

export default function PayPalRequest({ selected, onClick, editing }: Props) {
  return (
    <PaymentMethodBox editing={editing} onClick={onClick} selected={selected} value='paypal'>
      <div className='flex items-center'>
        <PayPal />
        <Text className='mis-2' size='lg' variant='buttonLabel'>
          PayPal
        </Text>
      </div>
    </PaymentMethodBox>
  );
}
